import React from 'react'

import { ITrustPilot } from '@/services/trustPilot'
import { Caption } from 'ethos-design-system'

import TrustPilotSimpleLogo from '../TrustPilotSimpleLogo'
import {
  TrustPilot4Stars,
  TrustPilot5Stars,
  TrustPilot45Stars,
  TrustPilot46Stars,
  TrustPilot48Stars,
} from '../TrustPilotStars'
import styles from './TrustPilotBanner.module.scss'

interface TrustPilotBannerProps {
  moduleData: {
    customText: string
  }
  trustPilot: ITrustPilot
}

const TrustPilotBanner: React.FunctionComponent<TrustPilotBannerProps> = ({
  moduleData,
  trustPilot,
}) => {
  let bannerContent
  let stars
  switch (trustPilot.trustPilotBannerStars) {
    case '4':
      stars = <TrustPilot4Stars />
      break
    case '4.5':
      stars = <TrustPilot45Stars />
      break
    case '4.6':
      stars = <TrustPilot46Stars />
      break
    case '4.8':
      stars = <TrustPilot48Stars />
      break
    case '5':
      stars = <TrustPilot5Stars />
      break
    default:
      stars = <TrustPilot5Stars />
  }

  if (moduleData.customText && moduleData.customText.length > 0) {
    bannerContent = (
      <Caption.Regular400>{moduleData.customText}</Caption.Regular400>
    )
  } else {
    bannerContent = (
      <>
        <span className={styles.text}>{trustPilot.trustPilotBannerText}</span>
        <div className={styles.stars}>{stars}</div>
        <TrustPilotSimpleLogo />
      </>
    )
  }

  return <div className={styles.trustPilotBanner}>{bannerContent}</div>
}

export default TrustPilotBanner
